import CopyToClipboard from "components/components/CopyToClipboard/CopyToClipboard";
import React from "react";

import {
  ClientDetailsContainer,
  ClientDetailsRow,
  Label,
  Value,
} from "./style";

export type PairProps = {
  label: string;
  value: string;
};

type ClientDetailsProps = {
  items: PairProps[];
};

const LabelValuePairWithCopyButton: React.FC<PairProps> = ({
  label,
  value,
}) => (
  <ClientDetailsRow>
    <Label>{label}</Label>
    <Value>{value}</Value>
    <CopyToClipboard value={value} label={label} />
  </ClientDetailsRow>
);

const LabelValuePairsList: React.FC<ClientDetailsProps> = ({ items }) => (
  <>
    {items.map((item, index) => (
      <LabelValuePairWithCopyButton
        key={index}
        label={item.label}
        value={item.value}
      />
    ))}
  </>
);

const ClientDetails: React.FC<ClientDetailsProps> = ({ items }) => (
  <ClientDetailsContainer>
    <LabelValuePairsList items={items} />
  </ClientDetailsContainer>
);

export default ClientDetails;
